import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control
import permissionDirective from '@/directive'
import checkPermission from '@/utils/permission'

Vue.use(permissionDirective)
Vue.prototype.$permission = function(value) {
  return checkPermission(value, store.getters.permissionList, store.getters.name, store.getters.roles)
}
export const EventBus = new Vue();
Vue.use(ElementUI, { locale })
Vue.use(VCharts)
import VueLazyload from 'vue-lazyload'

// 使用vue-lazyload
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'dist/error.png', // 图片加载失败时使用的图片源
  loading: 'dist/loading.gif', // 图片加载的路径
  attempt: 1 // 尝试加载次数
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js